export const messagesSelector = (reportKey) => state => state.messages[reportKey];
